import React from 'react'
import { Box, CircularProgress } from '@mui/material'

const Loading = ({color = 'info'}) => {
  return (
    <Box sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }}>
        <CircularProgress color={color} />
    </Box>
  )
}

export default Loading